var render, staticRenderFns
import script from "./cargoElUpload.vue?vue&type=script&lang=js&"
export * from "./cargoElUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30bf8983')) {
      api.createRecord('30bf8983', component.options)
    } else {
      api.reload('30bf8983', component.options)
    }
    
  }
}
component.options.__file = "src/components/Cargo/Common/cargoElUpload.vue"
export default component.exports